import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "descriptions left-align emphasis-red" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Mastery at crafting clean, maintainable, and testable web components. "),
  /*#__PURE__*/_createElementVNode("p", null, "Focus on best practices and team collaboration.")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "description-sentences left-align" }, [
  /*#__PURE__*/_createElementVNode("p", null, "I love creating easy-to-use and attractive user experiences."),
  /*#__PURE__*/_createElementVNode("p", null, "Let's get stuff done.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "proficiencies-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "section-title all-caps emphasis-red left-align" }, "proficiencies", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "(tap items for more!)", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "section-title emphasis-red all-caps left-align" }, " professional experience ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "section-title emphasis-red all-caps left-align" }, "education", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurvyArrow = _resolveComponent("CurvyArrow")!
  const _component_proficiencies_component = _resolveComponent("proficiencies-component")!
  const _component_experience_component = _resolveComponent("experience-component")!
  const _component_floating_label_component = _resolveComponent("floating-label-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.showTouchLabel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createVNode(_component_CurvyArrow, { pointDown: "" })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devProficiencies, (proficiency) => {
      return (_openBlock(), _createBlock(_component_proficiencies_component, {
        key: proficiency.title,
        title: proficiency.title,
        type: _ctx.ProficiencyType.Dev,
        techs: proficiency.techs,
        onUpdateMousePosition: _ctx.updateMousePosition,
        onHideYearsLabel: _cache[0] || (_cache[0] = 
        (value) => {
          _ctx.hideLabelDiv = value;
        }
      ),
        onSetTechYears: _cache[1] || (_cache[1] = 
        (value) => {
          _ctx.techYears = value;
        }
      )
      }, null, 8, ["title", "type", "techs", "onUpdateMousePosition"]))
    }), 128)),
    _hoisted_7,
    _hoisted_8,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers, (employer) => {
      return (_openBlock(), _createBlock(_component_experience_component, {
        key: employer.name,
        name: employer.name,
        "term-length": employer.termLength,
        descriptions: employer.descriptions,
        role: employer.role,
        url: employer.url
      }, null, 8, ["name", "term-length", "descriptions", "role", "url"]))
    }), 128)),
    _hoisted_9,
    _hoisted_10,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educations, (education) => {
      return (_openBlock(), _createBlock(_component_experience_component, {
        key: education.name,
        name: education.name,
        "term-length": education.termLength,
        descriptions: education.descriptions,
        url: education.url
      }, null, 8, ["name", "term-length", "descriptions", "url"]))
    }), 128)),
    _createVNode(_component_floating_label_component, {
      hide: _ctx.hideLabelDiv,
      "years-amount": _ctx.techYears,
      "mouse-position": _ctx.labelDivStyles
    }, null, 8, ["hide", "years-amount", "mouse-position"])
  ]))
}